import { achievementCodeDict, curriculumMap, gradeDict, schoolDict, subjectAreaDict, subjectDict, unitDict } from "@common/NewCurriculumCodes/CurriculumMap";
import { ProjectSchoolType, ProjectSharedState } from "../../stores/enums/ProjectStoreEnums";
import { ProjectSemesterType } from "./support/ProjectSemesterType";
import { ProjectStateType } from "./support/ProjectStateType";
import { ProjectType } from "./support/ProjectType";
import { SubjectType } from "./support/SubjectType";

export interface IProjectState {
	code: string; // "7ydoS21j"
	info: boolean; // true
	plan: boolean; // true
	exam: boolean; // true
	rag: boolean; // false
	answer: boolean; // true
	rubric: boolean; // true
	target: boolean; // false
	paper: boolean; // false
	submit: boolean; // false
}

export interface IProject {
	code: string; // "7ydoS21j"
	userCode: string; // "hPMqXBvV"
	name: string; // "111"
	templateName?: string; // null
	templateCode?: string; // null
	type: ProjectType, // "TEMPLATE" | "CUSTOM"; // "TEMPLATE"
	curriculumYear: string; // "2024"
	schoolType: ProjectSchoolType,
	grade: string; // "7"
	subject: SubjectType; // "MATH"
	subjectName: string; // "MATH"
	year: number; // 0
	semesterType: ProjectSemesterType, //string | null; // null

	chapter: string; // "111"
	startDatetime?: string; // null
	endDatetime?: string; // null
	description?: string; // null
	totalCount: number; // 0
	scoredCount: number; // 0
	submittedCount: number; // 0
	state: ProjectStateType,
	targetGroupName?: string; // null
	sharedState: ProjectSharedState, // "PRIVATE" | "PUBLIC"; // "PRIVATE"
	createdDatetime: string; // "2024-08-22T08:09:00"
	updatedDatetime: string; // "2024-08-22T08:09:00"
	projectState: IProjectState; // { ... }
	includedOnline?: boolean; // false,

	subjectRange?: string;

	// since ver 0.27, 2025-09-10, newACurriculumCode replaces schoolType,grade,subject, or some other properties
	// projects stored before 0.27 will have newACurriculumCode value as 0
	newACurriculumCode: number;

	
}

export class IProjectPropertyReader {

	// schoolType, grade, subject, subjectRange
	public static before027VerCurriculumInfo(project: IProject): [ProjectSchoolType, string, SubjectType, string?] {
		return [project.schoolType, project.grade, project.subject, project.subjectRange]; 
	}

	// make sure beforehand that project.newACurriculumCode is not 0
	public static after027VerCurriculumInfo(project: IProject): [string, string, string, string, string, string, string] {
		
		let row = curriculumMap[project.newACurriculumCode];

		const school = schoolDict[row.schoolCode];
		const grade = gradeDict[row.gradeCode];
		const subjectArea = subjectAreaDict[row.subjectAreaCode];
		const subject = subjectDict[row.subjectCode];
		const unit = unitDict[row.unitCode];
		const achievement = achievementCodeDict[row.achievementCode];

		return [school, grade, subjectArea, subject, unit, row.achievementCode, achievement]; 

		/*
		//   schoolCode: number;
  gradeCode: number;
  subjectAreaCode: number;
  subjectCode: number;
  unitCode: number;
  achievementCode: string;
*/
//		schoolCode: 3, gradeCode: 3, subjectAreaCode: 2, subjectCode: 11, unitCode: 66, achievementCode: "4국04-01" },
	}

	public static isBefore027Ver(project: IProject): boolean {
		return project.newACurriculumCode == 0 ? true : false;
	}

	public static isEmptyProject(project: IProject): boolean {
		return project.newACurriculumCode == -1 ? true : false;
	}
	
}

/*
const params = {
				curriculumYear,
				schoolType,
				subject,
				subjectName,
				subjectRange,
				name,
				grade,
				chapter,
				userCode,
				type: projectType,
				state: ProjectStateType.CREATED
			}*/